<snelstart-ui-details
  [config]="detailsConfig"
  [entityId]="id"

>

  <snelstart-ui-details-title>
    <div style="font-size: 18px">
      <strong>{{ this.customerResponse.code }} - {{ this.customerResponse.name }}</strong>
    </div>
  </snelstart-ui-details-title>
  <snelstart-ui-details-buttons>
    <snelstart-ui-button (click)="this.showDialogClientSettings()" icon="gear"
                         type="primary">Klantinstellingen
    </snelstart-ui-button>
  </snelstart-ui-details-buttons>

  <snelstart-ui-details-content>


    <!--        @if (this.clientEntity.taxId === undefined && this.clientEntity.taxIdWageTax === undefined) {-->
    <!--            <snelstart-ui-alert type="warning">-->
    <!--                Let op! Vul bij de klantinstellingen het fiscale nummer en belastingplicht in om de fiscale modules te-->
    <!--                activeren.-->
    <!--            </snelstart-ui-alert>-->
    <!--        }-->
    <!--       -->

    <div class="row d-flex">
      <div class="col">
        <snelstart-ui-card>
          <div class="card-header">
            SnelStart klantadministratie
          </div>
          <div class="card-body">
            @if (this.clientEntity.adminEntities === undefined || this.clientEntity.adminEntities.length === 0) {
              <p>Koppel een SnelStart-administratie om deze module te activeren.</p>
            } @else {
              <p>Openen klantadministratie in SnelStart Polaris.</p>
            }
          </div>
          <snelstart-ui-button (click)="this.openTaxAppInNewTab('admin')"
                               [disabled]="this.clientEntity.adminEntities === undefined || this.clientEntity.adminEntities.length === 0"
                               [type]="(this.clientEntity.adminEntities === undefined || this.clientEntity.adminEntities.length === 0) ? 'secondary' : 'primary'"
                               class="card-button"
                               iconRight="arrow-up-right-from-square"
          >Administratie
          </snelstart-ui-button>
        </snelstart-ui-card>
      </div>
      <div class=col>
        <snelstart-ui-card>
          @if (this.clientEntity.corporateTax) {
            <div class="card-header">
              Vennootschapsbelasting
            </div>
          } @else if (this.clientEntity.incomeTax) {
            <div class="card-header">
              Inkomstenbelasting
            </div>
          } @else {
            <div class="card-header">
              Inkomstenbelasting of vennootschapsbelasting
            </div>
          }
          <div class="card-body">
            @if (clientEntity.incomeTax && clientEntity.taxId && !!customerResponse.fiscalIdentifier?.trim()) {
              <p>Indienen aangiften en voorlopige aanslagen inkomstenbelasting
              </p>
            } @else if (clientEntity.corporateTax && clientEntity.taxId) {
              <p>Indienen aangiften en voorlopige aanslagen vennootschapsbelasting .</p>
            } @else if (clientEntity.taxId == null) {
              <p>Stel belastingplicht en fiscaal nummer in om de module te activeren.</p>
            } @else {
              <p>Stel belastingplicht en fiscaal nummer in om de module te activeren.</p>
            }
          </div>
          <div>
            @if (this.clientEntity.incomeTax) {
              <snelstart-ui-button (click)="this.openTaxAppInNewTab('tax-income')"
                                   [disabled]="!this.clientEntity.incomeTax || this.clientEntity.taxId == null"
                                   [type]="(!this.clientEntity.incomeTax || this.clientEntity.taxId == null) ? 'secondary' : 'primary'"
                                   class="card-button"
                                   iconRight="arrow-up-right-from-square"

              >Inkomstenbelasting
              </snelstart-ui-button>
            } @else if (this.clientEntity.corporateTax) {
              <snelstart-ui-button (click)="this.openTaxAppInNewTab('tax-corporate')"
                                   [disabled]="!this.clientEntity.corporateTax || this.clientEntity.taxId == null"
                                   [type]="(!this.clientEntity.corporateTax || this.clientEntity.taxId == null) ? 'secondary' : 'primary'"
                                   class="card-button"
                                   iconRight="arrow-up-right-from-square"
              >Vennootschapsbelasting
              </snelstart-ui-button>
            } @else {
              <snelstart-ui-button (click)="this.openTaxAppInNewTab('tax-corporate')"
                                   [disabled]="true"
                                   class="card-button"
                                   iconRight="arrow-up-right-from-square"
                                   type="secondary"
              >Module (nog) niet geactiveerd
              </snelstart-ui-button>
            }
          </div>
        </snelstart-ui-card>
      </div>
    </div>
    <div class="row d-flex pt-3">
      <div class=col>
        <snelstart-ui-card>
          <div class="card-header">
            Omzetbelasting
          </div>
          <div class="card-body">
            @if (!this.clientEntity.valueAddedTax) {
              <p>Stel belastingplicht omzetbelasting in om de module te activeren.</p>
            } @else {
              <p>Aangiften omzetbelasting en opgaves ICP (ook zonder SnelStart Administratie).</p>
            }
          </div>
          <div>
            <snelstart-ui-button (click)="this.openTaxAppInNewTab('tax-vat')"
                                 [disabled]="!this.clientEntity.valueAddedTax"
                                 [type]="!this.clientEntity.valueAddedTax ? 'secondary' : 'primary'"
                                 class="card-button"
                                 iconRight="arrow-up-right-from-square"
                                 type="secondary"
            >Omzetbelasting
            </snelstart-ui-button>
          </div>
        </snelstart-ui-card>
      </div>
      <div class=col>
        <snelstart-ui-card>
          <div class="card-header">
            <snelstart-ui-badge label="Accountant Pro"
                                type="success"
            >
            </snelstart-ui-badge>
            Jaarrapportage
          </div>
          <div class="card-body">
            @if (this.intermediairyEntity.licenceName === 'Accountant Pro') {
              @if (!this.clientEntity.sbiCode || !this.clientEntity.kvkId || !this.clientEntity.classificatie) {
                <p>Vul KVK-nummer, SBI-code en bedrijfsklasse in om de module te activeren.</p>
              } @else {
                <p>Jaarrrapportages genereren voor rechtspersonen
                  en natuurlijke personen en publiceren voor micro en kleine rechtspersonen.</p>
              }
            } @else {
              <p>Onderdeel van de SnelStart Accountant Pro licentie.
                Contact onze klantenservice voor een proefperiode.</p>
            }
          </div>
          <div>
            <snelstart-ui-button (click)="this.openTaxAppInNewTab('pm-report')"
                                 [disabled]="this.intermediairyEntity.licenceName !== 'Accountant Pro' || !this.clientEntity.kvkId || !this.clientEntity.sbiCode || !this.clientEntity.classificatie"
                                 [type]="(this.intermediairyEntity.licenceName !== 'Accountant Pro' || !this.clientEntity.kvkId || !this.clientEntity.sbiCode || !this.clientEntity.classificatie) ? 'secondary' : 'primary'"
                                 class="card-button"
                                 iconRight="arrow-up-right-from-square"
                                 type="secondary"
            >Jaarrapportage
            </snelstart-ui-button>
          </div>
        </snelstart-ui-card>
      </div>
    </div>

    @if (this.clientEntity.incomeTax) {
      <div class="row d-flex pt-3">
        <div class=col>
          <snelstart-ui-card>
            <div class="card-header">
              Toeslagen
            </div>
            <div class="card-body">
              <p>Aanvragen, wijzigen en stopzetten van toeslagen.</p>
            </div>
            <div>
              <snelstart-ui-button (click)="this.openTaxAppInNewTab('tax-allowance')"
                                   [type]="(!this.clientEntity.incomeTax || this.clientEntity.taxId == null) ? 'secondary' : 'primary'"
                                   class="card-button"
                                   iconRight="arrow-up-right-from-square"
              >Toeslagen
              </snelstart-ui-button>
            </div>
          </snelstart-ui-card>
        </div>
        <div class=col>
          <snelstart-ui-card>
            <div class="card-header">
              <snelstart-ui-badge label="Accountant Pro"
                                  type="success"
              >
              </snelstart-ui-badge>
              Erfbelasting
            </div>
            <div class="card-body">
              <p>Module is nog niet beschikbaar (verwacht 2e kwartaal 2026).</p>
            </div>
            <div>
              <snelstart-ui-button (click)="this.openTaxAppInNewTab('tax-bezwaar')"
                                   [disabled]="true"
                                   class="card-button"
                                   iconRight="arrow-up-right-from-square"
                                   type="secondary"
              >Erfbelasting
              </snelstart-ui-button>
            </div>
          </snelstart-ui-card>
        </div>
      </div>
    }

    <div class="row d-flex pt-3">
      <div class=col>
        <snelstart-ui-card>
          <div class="card-header">
            <snelstart-ui-badge label="Accountant Pro"
                                type="success"
            >
            </snelstart-ui-badge>
            Salarisadministratie
          </div>
          <div class="card-body">
            @if (this.intermediairyEntity.licenceName === 'Accountant Pro') {
              @if (this.clientEntity.wageTax) {
                <p>Salarisadministratie voor DGA's en
                  werknemers zonder CAO/pensioenregeling.</p>
              } @else {
                <p>Stel inhoudingsplicht loonheffingen in om de module te activeren.</p>
              }
            } @else {
              <p>Onderdeel van de SnelStart Accountant Pro licentie.
                Contact onze klantenservice voor een proefperiode.</p>
            }
          </div>
          <div>
            <snelstart-ui-button (click)="this.openTaxAppInNewTab('tax-wage')"
                                 [disabled]="this.intermediairyEntity.licenceName !== 'Accountant Pro' || !this.clientEntity.wageTax"
                                 [type]="(this.intermediairyEntity.licenceName !== 'Accountant Pro' || !this.clientEntity.wageTax) ? 'secondary' : 'primary'"
                                 class="card-button"
                                 iconRight="arrow-up-right-from-square"
            >Salarisadministratie
            </snelstart-ui-button>
          </div>
        </snelstart-ui-card>
      </div>
      <div class=col>
        <snelstart-ui-card>
          <div class="card-header">
            <snelstart-ui-badge label="Accountant Pro"
                                type="success"
            >
            </snelstart-ui-badge>
            @if (this.clientEntity.corporateTax) {
              Dividendbelasting
            } @else if (this.clientEntity.incomeTax) {
              Schenkbelasting
            } @else {
              Dividend- of schenkbelasting
            }

          </div>
          <div class="card-body">
            @if (this.intermediairyEntity.licenceName === 'Accountant Pro') {
              @if (this.clientEntity.incomeTax) {
                <p>Aangiften schenkbelasting opstellen en indienen.</p>
              } @else if (this.clientEntity.corporateTax) {
                <p>Aangiften dividendbelasting opstellen en indienen.</p>
              } @else {
                <p>Stel belastingplicht ib/vpb in om deze modules te activeren.</p>
              }
            } @else {
              <p>Onderdeel van de SnelStart Accountant Pro licentie.
                Contact onze klantenservice voor een proefperiode.</p>
            }
          </div>
          <div>
            @if (this.clientEntity.incomeTax) {
              <snelstart-ui-button (click)="this.openTaxAppInNewTab('tax-donation')"
                                   [disabled]="this.intermediairyEntity.licenceName !== 'Accountant Pro' || !this.clientEntity.incomeTax"
                                   [type]="(!this.clientEntity.incomeTax || this.clientEntity.taxId == null) ? 'secondary' : 'primary'"
                                   class="card-button"
                                   iconRight="arrow-up-right-from-square"

              >Schenkbelasting
              </snelstart-ui-button>
            } @else if (this.clientEntity.corporateTax) {
              <snelstart-ui-button (click)="this.openTaxAppInNewTab('tax-dividend')"
                                   [disabled]="this.intermediairyEntity.licenceName !== 'Accountant Pro' || !this.clientEntity.corporateTax || !intermediairyEntity.beconId"
                                   [type]="(!this.clientEntity.corporateTax) ? 'secondary' : 'primary'"
                                   class="card-button"
                                   iconRight="arrow-up-right-from-square"
              >Dividendbelasting
              </snelstart-ui-button>
            } @else {
              <snelstart-ui-button (click)="this.openTaxAppInNewTab('tax-dividend')"
                                   [disabled]="true"
                                   class="card-button"
                                   iconRight="arrow-up-right-from-square"
                                   type="secondary"
              >Module (nog) niet geactiveerd
              </snelstart-ui-button>
            }
          </div>
        </snelstart-ui-card>
      </div>
    </div>
    <div class="row d-flex pt-3">
      <div class=col>
        <snelstart-ui-card>
          <div class="card-header">
            Online bezwaar
          </div>
          <div class="card-body">
            @if (this.intermediairyEntity.certValidUntil === undefined) {
              <p>Upload een PKI-certificaat in via de kantoorinstellingen om de module te
                activeren.</p>
            } @else {
              <p>Online bezwaar tegen beschikkingen ib/vpb/btw van de Belastingdienst.</p>
            }
          </div>
          <div>
            <snelstart-ui-button (click)="this.openTaxAppInNewTab('tax-bezwaar')"
                                 [disabled]="(this.intermediairyEntity.certValidUntil === undefined || this.clientEntity.taxId === undefined)"
                                 [type]="(this.intermediairyEntity.certValidUntil === undefined || this.clientEntity.taxId === undefined) ? 'secondary' : 'primary'"
                                 class="card-button"
                                 iconRight="arrow-up-right-from-square"
            >Online bezwaar
            </snelstart-ui-button>
          </div>
        </snelstart-ui-card>
      </div>
      <div class=col>
        <snelstart-ui-card>
          <div class="card-header">
            Machtigingen
          </div>
          <div class="card-body">
            @if (this.intermediairyEntity.certValidUntil === undefined) {
              <p>Upload een PKI-certificaat in via de kantoorinstellingen om de module te
                activeren.</p>
            } @else {
              <p>Beheer machtigingen voor ontvangen serviceberichten Belastingdienst.</p>
            }
          </div>
          <div>
            <snelstart-ui-button (click)="this.openTaxAppInNewTab('tax-muma')"
                                 [disabled]="(this.intermediairyEntity.certValidUntil === undefined || this.clientEntity.taxId === undefined)"
                                 [type]="(this.intermediairyEntity.certValidUntil === undefined || this.clientEntity.taxId === undefined) ? 'secondary' : 'primary'"
                                 class="card-button"
                                 iconRight="arrow-up-right-from-square"
            >Machtigingen
            </snelstart-ui-button>
          </div>
        </snelstart-ui-card>
      </div>
    </div>
  </snelstart-ui-details-content>
</snelstart-ui-details>

<snelstart-venture-fiscaal-domain-logic-client (clientChanges)="onClientChanged($event)"
                                               [(dialogVisible)]="dialogClientSettingsVisible"
                                               [clientFg]="clientFormGroup"
                                               [customer]="customerResponse">
</snelstart-venture-fiscaal-domain-logic-client>
